export default "images/前车风险提示.png";